import { Icon, Tooltip } from "@chakra-ui/react";
import { RemixiconComponentType, RiQuestionLine } from "@remixicon/react";

interface Props {
  title: string;
  icon?: RemixiconComponentType;
}

export const PrimaryTooltip = ({
  title,
  icon = RiQuestionLine,
  ...rest
}: Props) => {
  return (
    <Tooltip label={title} placement="top-start" closeOnClick={false} {...rest}>
      <span>
        <Icon as={icon} textStyle={"b-sm"} />
      </span>
    </Tooltip>
  );
};
